module.exports = __webpack_public_path__ + "img/catman.f05c4ede.png";